module.exports = __webpack_public_path__ + "img/Fulpmes.add789c4.jpg";